import React, { useState } from "react";
import ConsumeFeedControls from "./ConsumeFeedControls.tsx";
import ConsumeFeedUI from "./ConsumeFeedUI.tsx";
import ManualProductPicker from "./ManualProductPicker.tsx";
import { useStockData } from "hooks/useStockData.ts";
import { useBarcodeScanning } from "hooks/useBarcodeScanning.ts";
import { useCameraFeedState } from "hooks/useCameraFeedState.ts";
import "./ConsumeFeedContent.css";

const ConsumeFeedContent: React.FC = () => {
  // Custom hooks for different concerns
  const { barcodeMap, productItemsMap } = useStockData();
  const { showStockOverlay, toggleStockOverlay } = useCameraFeedState();
  const {
    barcode,
    scannedProduct,
    barcodeNotFound,
    consumptionMode,
    scanResultState,
    clearScan,
  } = useBarcodeScanning({ barcodeMap, productItemsMap });

  // Manual picker state
  const [showManualPicker, setShowManualPicker] = useState(false);

  const handleOpenManualPicker = () => {
    setShowManualPicker(true);
  };

  const handleCloseManualPicker = () => {
    setShowManualPicker(false);
  };

  return (
    <div className="camera-feed">
      {/* Controls */}
      <ConsumeFeedControls
        showStockOverlay={showStockOverlay}
        onToggleStockOverlay={toggleStockOverlay}
      />
      
      {/* Show scanning disabled overlay when in consumption mode */}
      {consumptionMode === 'consuming' && (
        <div className="camera-feed__scanning-disabled">
          <div className="camera-feed__scanning-disabled-content">
            📱 Scanning paused
          </div>
        </div>
      )}
      
      {/* Overlays - video is now provided by SharedCameraLayout */}
      <ConsumeFeedUI
        consumptionMode={consumptionMode}
        scannedProduct={scannedProduct}
        barcodeNotFound={barcodeNotFound}
        scanResultState={scanResultState}
        showStockOverlay={showStockOverlay}
        barcode={barcode}
        onClearScan={clearScan}
        onToggleStockOverlay={toggleStockOverlay}
        onOpenManualPicker={handleOpenManualPicker}
      />

      {/* Manual Product Picker Modal */}
      {showManualPicker && (
        <ManualProductPicker onClose={handleCloseManualPicker} />
      )}
    </div>
  );
};

export default ConsumeFeedContent; 
